export enum FormComponentsEnum {
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  TOGGLE = 'TOGGLE',
}

export const PROMO_CODE_MAX_LENGTH = 32 as const;
